import SimpleBlockContent from '@components/bits/SimpleBlockContent';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';
type Props = {
  heading;
  text;
};

const HeaderText: FunctionComponent<Props> = ({ heading, text }) => {
  return (
    <div className={`article-content ${styles.root}`}>
      {heading && <h4>{heading}</h4>}
      {text && <SimpleBlockContent data={text} />}
    </div>
  );
};

export default React.memo(HeaderText);
